import styled from 'styled-components';

const Img = styled.img`
  max-width: ${props => props.iconWidth ? props.iconWidth : "40px"};
  min-width: ${props => props.iconWidth ? props.iconWidth : "40px"};
  max-height: ${props => props.iconHeight ? props.iconHeight : "40px"};
  min-height: ${props => props.iconHeight ? props.iconHeight : "40px"};
`

export { Img }